/* eslint-disable no-return-assign */
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Editor, EditorState, convertFromRaw, Modifier } from 'draft-js'

import 'draft-js/dist/Draft.css'
import './style.css'
import { isJsonString } from '../../../resources/utilities'

export default class RichTextViewer extends React.Component {
  constructor (props) {
    super(props)
    let editorState
    if (!isJsonString(props.content)) {
      editorState = this.getNewEditorState(props.content, EditorState.createEmpty())
    } else {
      editorState = EditorState.createEmpty()
    }
    this.state = {
      counter: 0,
      viewState: 'collapsed',
      needExpanding: undefined,
      editorState: editorState
    }
  }

  modifyEditorState (content, editor) {
    if (isJsonString(content)) {
      const rawObject = JSON.parse(content)
      content = convertFromRaw(rawObject)
      this.setState({editorState: EditorState.createWithContent(content)})
    }
  }

  componentWillReceiveProps (nextProps) {
    this.modifyEditorState(nextProps.content, this.state.editorState)
    this.setState({
      needExpanding: this.refs.editor.scrollHeight > 100
    })
  }

  componentWillMount () {
    this.modifyEditorState(this.props.content, this.state.editorState)
  }

  updateExpandableState () {
    this.setState({
      needExpanding: this.refs.editor.scrollHeight > 100
    })
  }

  componentDidMount () {
    this.updateExpandableState()
  }

  getNewEditorState (text, editor) {
    const selection = editor.getSelection()
    const contentState = editor.getCurrentContent()
    const ncs = Modifier.insertText(contentState, selection, text)
    return EditorState.push(editor, ncs, 'insert-fragment')
  }

  handleElementClick (elementKey) {
    if (this.props.handleElementClick) {
      this.props.handleElementClick(elementKey)
    }
  }

  render () {
    const {editorState} = this.state
    return (
      <Fragment>
        {this.state.needExpanding
          ? <div className='pull-right clickable'>
            <div onClick={() => {
              this.setState({
                viewState: this.state.viewState === 'collapsed' ? 'expanded' : 'collapsed'})
            }}><i className={`fa ${this.state.viewState === 'collapsed' ? 'fa-angle-down' : 'fa-angle-up'}`} style={{fontSize: '36px'}} /></div>
          </div>
          : null
        }
        <div className={`RichViewer-root ${this.props.handleElementClick ? 'clickable' : null}`} onClick={() => this.handleElementClick(this.props.elementKey)}>
          <div ref={'editor'} className={`RichViewer-editor ${this.state.viewState}`}>
            <Editor
              editorState={editorState}
              readOnly
              ref='editor'
            />
          </div>
        </div>
      </Fragment>
    )
  }
}

RichTextViewer.propTypes = {
  content: PropTypes.string.isRequired,
  handleElementClick: PropTypes.func,
  elementKey: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/common/RichTextViewer/RichTextViewer.js